import sanitizeHtml from "sanitize-html";
import { cn } from "@gettactic/helpers/src/css/cn";
import { toRichTextHtml } from "@gettactic/helpers/src/workplace-requests/richText";

type Props = { value: string; className?: string };

export function TextEditorContent({ value, className = "" }: Props) {
  return (
    <div className={cn("prose prose-sm max-w-none", className)}>
      <div
        dangerouslySetInnerHTML={{
          // Plain-text bodies keep their newlines; see toRichTextHtml.
          __html: sanitizeHtml(toRichTextHtml(value), {
            allowedClasses: { span: ["bg-yellow-400"] }
          })
        }}
      />
    </div>
  );
}
